import clsx from "clsx";
import React, { CSSProperties } from "react";
import { Fonts } from "../contents/Fonts";

export type Variant =
  | "H1"
  | "H2"
  | "H3"
  | "H4"
  | "H5"
  | "H6"
  | "SubTitle1"
  | "SubTitle2"
  | "Body1"
  | "Body2"
  | "Body3"
  | "Caption1"
  | "Caption2"
  | "Logo"
  | "SubEnglish"
  | "Button1"
  | "MainSubContent"
  | "Name"
  | "NameContent"
  | "Content1"
  | "mbaContent"
  | "ContentHeader"
  | "ContentHeader2"
  | "ContentHeader3"
  | "ModuleText"
  | "SimModuleText"
  | "SimModuleSubText"
  | "SimModuleMentalSubText"
  | "mSimModuleText"
  | "mSimModuleText2"
  | "elderContent"
  | "elderNews"
  | "teamSubTitle"
  | "researchTitle";

export interface TypographyProps {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  variant: Variant;
  htmlColor?: string;

  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Typography = (props: TypographyProps) => {
  const { children, className, style, variant, htmlColor, onClick } = props;

  // const theme = useTheme() as Theme;

  return (
    <span
      onClick={onClick}
      className={clsx(className)}
      style={{
        ...Fonts[variant],
        fontFamily: "Roboto",
        color: htmlColor,
        ...style,
      }}
    >
      {children}
    </span>
  );
};
